module.exports = __webpack_public_path__ + "img/pd.0756cd32.jpg";